import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';
import { Typography } from '../Typography';
import { BADGE_POSITION_MAP, BADGE_SIZE_MAP } from './Badge.constants';
import { BadgeProps } from './Badge.types';

export const Badge = ({
  size = 'lg',
  className,
  value = '',
  position = 'top-right',
  children,
  typographyClassName,
  badgeClassName,
  isVisible = true,
  ...rest
}: BadgeProps) => {
  if (!isVisible) {
    return children;
  }

  return (
    <div className={flattenClassNames(['relative', className])}>
      <div>{children}</div>
      <div
        className={flattenClassNames([
          'absolute flex items-center justify-center rounded-[50%] bg-error-400',
          BADGE_POSITION_MAP[position],
          BADGE_SIZE_MAP[size],
          badgeClassName,
          rest.top,
          rest.left,
          rest.right,
          rest.bottom,
        ])}
      >
        <Typography className={flattenClassNames([typographyClassName ?? '!text-common-white'])}>
          {value}
        </Typography>
      </div>
    </div>
  );
};
